import React, { useContext, useRef } from "react";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import {
  AlertError,
  AlertOK,
  FormatThaiCard,
  FormatThaiCard3,
  FormatThaiDate,
  FormAutoB,
  GetHeaderStyle,
  IsEmptyObject,
  IsNullOrEmptyObject,
} from "../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import styled from "styled-components";
import {
  AiOutlineSearch,
  AiOutlinePaperClip,
  AiOutlinePlus,
  AiOutlineInfo,
  AiOutlineClose,
  AiOutlineHistory,
  AiOutlineDownload,
  AiOutlineUpload,
} from "react-icons/ai";
import { FcPicture, FcReadingEbook } from "react-icons/fc";
import StudyParts from "./StudyParts";
import { dateFilter, textFilter } from "react-bootstrap-table2-filter";
import {
  CardReadCommandContext,
  PersonInfoContext,
  WsCmmdContext,
  WsContext,
} from "../../App";
import FileUploader from "./FileUploader";
import { BiClipboard, BiLayer } from "react-icons/bi";
import ClipboardPaster from "./ClipboardPaster";
import { RiAttachmentLine } from "react-icons/ri";
import FileUploadAutoPreview from "./FileUploadAutoPreview";
import { GiAttachedShield } from "react-icons/gi";
import ConfirmDialogB from "../components/ConfirmDialogB";
import { ClipboardImageHelper } from "./ClipboardHelper";

import XrayImage from "../../images/x-ray.png";
import { StudyService } from "../../model/study";
import { FaExclamation, FaRegFileAlt, FaRegIdCard } from "react-icons/fa";
import { DefaultEditorValue } from "../../core/Helper2";
import FormInvoice from "../back-office-forms/002_invoice";
import { Oval } from "react-loading-icons";
import { MdScanner } from "react-icons/md";
import { TokenService } from "../../model/token";

function StudyEditor(props) {
  const {
    selectedRow,
    userDetail,
    //showEditor,
    //setShowEditor,
    loading,
    setLoading,
  } = props;

  const [showEditor, setShowEditor] = props.showEditor;
  const dispatch = useDispatch();
  const [dataX, setDataX] = useState(null);
  const [searchStateA, setSearhStateA] = props.searchState;
  const [searchB, setSearchB] = props.searchB; // TechWorklist
  const [searchGood, setSearchGood] = props.searchGood;
  const [showImage, setShowImage] = props.showImage;
  const [updateFlag, setUpdateFlag] = props.updateFlag;
  const [priceData, setPriceData] = useState([]);
  const [priceDataRemove, setPriceDataRemove] = useState([]);
  const [params, setParams] = props.params;
  const [idcard, setIdCard] = useState("");
  //** Normal upload */
  const [showUpload, setShowUpload] = useState({ show: false });
  const [showClipboard, setClipboard] = useState({ show: false });
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });

  //** มีการ drop form upload */
  const [fileDrop, setFileDrop] = useState(null);
  const [autoUpload, setAutoUpload] = useState({ show: false });

  const [resultExpected, setResultExpected] = useState(new Date());

  const [fieldGroup1, setFieldGroup1] = useState([]);
  const [fieldGroup2, setFieldGroup2] = useState([]);
  const [fieldGroup3, setFieldGroup3] = useState([]);

  const [invoiceFrm, setInvoiceFrm] = useState(DefaultEditorValue);

  const defaultImportantEdit = {
    newFileUpload: false,
    changedItem: false,
    changedRemark: false,
    changedUrgency: false,
    disableResultExpected: false,
  };

  //** ตรวจจับการ upload เพื่อแจ้ง notification ที่สำคัญ */
  const [importantEdit, setImportantEdit] = useState(defaultImportantEdit);

  const refForm1 = useRef(null);
  const refFrom2 = useRef(null);
  const refForm3 = useRef(null);

  const uploadType = { FILE: 1, CAPTURED: 2 };

  const keyV = 86;

  const [ws, setWs] = useContext(WsContext);

  const cardReaderCmd = useContext(CardReadCommandContext);
  const personInfo = useContext(PersonInfoContext);
  const { sendMessage, readyState } = cardReaderCmd;
  const [subLoading, setSubLoading] = useState(false);
  const [loadingScn, setLoadingScn] = useState(false);

  const checkFocus = () => {
    console.log("focus ok");
    alert("ok");
  };

  /** SHOW Effected */
  useEffect(() => {
    //** */
    if (showEditor?.show === true) {
      document.addEventListener("keydown", checkKeyDown, false);

      getInfo(() => {});
    }

    return () => {
      clearAll();
    };
  }, [showEditor]);

  /** ผลการอ่านบัตรประชาชน */
  useEffect(() => {
    if (showEditor?.show) {
      if (personInfo.IdCardNo === 0) {
        AlertError("อ่านบัตรล้มเหลว", dispatch);
        return;
      }

      setDataX((pv) => {
        pv.studyInfo.patients_idcard = personInfo?.IdCardNo;
        pv.studyInfo.patients_name =
          personInfo?.Prefix?.PrefixText +
          personInfo?.Firstname +
          " " +
          personInfo?.Lastname;
        pv.studyInfo.patients_name_eng =
          personInfo?.PrefixEn?.PrefixText +
          personInfo?.FirstnameEng +
          " " +
          personInfo?.LastnameEng;
        return { ...pv };
      });
      setSubLoading(false);
    }
  }, [personInfo]);

  const clearAll = () => {
    setFieldGroup1(null);
    setFieldGroup2(null);
    setFieldGroup3(null);
    setDataX(null);
    setImportantEdit(defaultImportantEdit);
  };

  //** Effected DATAX */
  useEffect(() => {
    if (dataX && dataX.priceItems) {
      setPriceDataRemove([]);
    }
    return () => {};
  }, [dataX?.priceItems]);

  useEffect(() => {
    if (dataX && dataX.priceItems) {
      setPriceData(dataX.priceItems);
    }
    return () => {
      setPriceData([]);
    };
  }, [dataX?.priceItems]);

  //----------------------------------------------------------------------
  // web socket command message
  const [wsCmd, setWsCmd] = useContext(WsCmmdContext);

  //** Web Socket comand from web-socket server */
  // useEffect(() => {
  //   // get instructin from web socket server
  //   // if no any message from server will not reminder anything ...
  // }, [wsCmd]);

  //** File dropping check */
  // useEffect(() => {
  //
  // }, [fileDrop]);

  const handleClose = () => {
    document.removeEventListener("keydown", checkKeyDown, false);
    setFileDrop(null);
    setShowEditor({ show: false });
  };

  //**รายการ */
  useEffect(() => {
    if (dataX == null) return;

    if (dataX?.studyInfo?.custid == null) {
      setDataX((pv) => {
        pv.studyInfo.custid = props?.refData?.FirstCustomer[0]?.custid;
        pv.studyInfo.custid_sender = props?.refData?.FirstCustomer[0]?.custid;
        pv.studyInfo.sender_name = props?.refData?.FirstCustomer[0]?.cust_name;
        pv.studyInfo.cust_short = props?.refData?.FirstCustomer[0]?.cust_name;
        pv.studyInfo.price_list_id =
          props?.refData?.FirstPriceList[0]?.price_list_id;

        pv.studyInfo.descript = props?.refData?.FirstPriceList[0]?.descript;
        //** dummy radiologist
        if (showEditor?.isOldStudy) {
          pv.studyInfo.radi_staffid = props?.refData?.DummyRadi[0]?.itemId;
          pv.studyInfo.radi_staff_name = props?.refData?.DummyRadi[0]?.itemName;
        }

        return { ...pv };
      });

      setParams((pv) => {
        pv.price_list_id = props?.refData?.FirstPriceList[0]?.price_list_id;
        pv.custid = props?.refData?.FirstCustomer[0].custid;
        pv.custid_sender = props?.refData?.FirstCustomer[0].custid;
        return { ...pv };
      });

      return;
    }

    setFieldGroups();
    return () => {};
  }, [dataX, params, importantEdit, resultExpected, subLoading]);

  //**Upload from clipboard */
  const handleClibboard = () => {
    setConfirm({
      show: true,
      title: "ต้องการ upload ภาพที่ทำการ Copy จากคลิปบอร์ด",
      action: (value) => {
        if (value === true) {
          ClipboardImageHelper({ userDetail, selectedRow })
            .then((ret) => {
              if (ret === "ok") {
                updateAttachedFile(() => {});
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
    });
  };

  //** Detecting keydown from user  */
  const checkKeyDown = async (evv) => {
    if (evv.ctrlKey === true && evv.keyCode === keyV) {
      // ("ready ctrl+v");
      const permission = await navigator.permissions.query({
        name: "clipboard-read",
      });

      if (permission.state === "granted") {
        const clipboardContents = await navigator.clipboard.read();
        for (const item of clipboardContents) {
          if (item.types.includes("text/plain")) {
            return;
          }
          if (item.types.includes("image/png")) {
            evv.preventDefault();
            handleClibboard();
            return false;
          }
        }
      }
    }
    return false;
  };

  //** GET STUDY INFO */
  const getInfo = (callback) => {
    if (props.selectedRow == null) return;

    postInfo((type, data) => {
      // debug today

      if (type === "ok") {
        setDataX({
          studyInfo: {
            ...data.StudyInfo[0],
            patients_idcard:
              data &&
              data.StudyInfo[0]?.patients_idcard &&
              FormatThaiCard(data.StudyInfo[0]?.patients_idcard),
          },
          attachedFile: data.StudyFileAttached,
          priceItems: data.PriceItems,
          resultInfo: data.StudyResults,
        });

        let info = data.StudyInfo[0];

        setParams((pv) => {
          pv.custid = info?.custid ?? 0;
          pv.custid_sender = info?.custid_sender ?? -1;
          pv.brchpatrightid = info?.brchpatrightid ?? pv.brchpatrightid;
          pv.price_list_id = info?.price_list_id ?? -1;
          return { ...pv };
        });

        setImportantEdit((p) => {
          p.disableResultExpected =
            data?.StudyInfo[0]?.urgenttypeid == 1 ||
            data?.StudyInfo[0]?.urgenttypeid == null
              ? false
              : true;
          return { ...p };
        });

        callback();
      } else {
        dispatch(
          setReminder({ show: true, message: data.message, type: "error" }),
        );
      }
    });
  };

  const postInfo = (callback) => {
    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/getStudyInfo",
        {
          StudyInfo: { pacs_study_id: props.selectedRow.pacs_study_id },
          UserInfo: userDetail,
        },
        HttpJsonHeader,
      )
      .then((res) => {
        callback("ok", res.data);
      })
      .catch((err) => {
        callback("error", err);
      });
  };
  //** รีเฟรชรายการไฟล์หลังทำการ upload แล้ว */
  const updateAttachedFile = (callback) => {
    postInfo((type, data) => {
      if (type === "ok") {
        setDataX((pv) => {
          pv.attachedFile = data.StudyFileAttached;
          return { ...pv };
        });
        setImportantEdit((pv) => {
          pv.newFileUpload = true;
          return { ...pv };
        });
        callback();
      }
    });
  };

  //** Delete image */
  const deleteImage = (item) => {
    if (
      dataX.studyInfo.rad_resulted === "y" ||
      dataX.studyInfo.diag_finish === "y"
    ) {
      dispatch(
        setReminder({
          show: true,
          message: (
            <>
              <div>รังสีแพทย์รับเคสแล้ว</div> <div>ไม่สามารถยกเลิกไฟล์ได้</div>
            </>
          ),
          type: "error",
        }),
      );
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/remove-study-imageupload",
        {
          UserInfo: userDetail,
          ImageInfo: item,
        },
        HttpJsonHeader,
      )
      .then((ret) => {
        updateAttachedFile(() => {
          setImportantEdit((pv) => {
            pv.newFileUpload = true;
            return { ...pv };
          });

          dispatch(
            setReminder({
              show: true,
              message: "ยกเลิกไฟล์แล้ว",
              type: "success",
            }),
          );
        });

        /** ------------ */
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" }),
        );
      });
  };

  //** ID-Card update */
  const handlelIdCardChange = (e) => {
    e.preventDefault();
    // var value = FormatThaiCard(e.target.value);
    var value = FormatThaiCard3(e.target.value);

    e.target.value = value;
    setDataX((p) => {
      p.studyInfo.patients_idcard = value;
      return { ...p };
    });

    // if (e.target.value.length < 17) {
    //   setIdCard(value);
    //   e.target.value = value;
    // } else {
    //   e.target.value = idcard;
    // }
  };

  /** เปิดตัวช่วยสแกนเอกสาร */
  const openRcxScanUrl = async (e) => {
    e.preventDefault();

    // ** get token
    setLoadingScn(true);
    // ** ใช้ Token
    // let useToken = false;
    // if (useToken) {
    //   let tokenInfo = await TokenService.GetScanToken(
    //     { study_id: selectedRow?.pacs_study_id },
    //     userDetail
    //   );
    //   console.log("ResponseToken is ", tokenInfo);
    //   console.log(
    //     "url",
    //     `rcxscan://?token=${tokenInfo?.toke}&pacs_study_id=${selectedRow?.pacs_study_id}&staffid=${userDetail?.staffid}&url=${process.env.REACT_APP_API}`
    //   );
    // }

    //** สร้าง Link เพื่อ เปิดตัวแสกน */
    var a = document.createElement("a");
    a.href = `rcxscan://?pacs_study_id=${selectedRow?.pacs_study_id}&staffid=${userDetail?.staffid}&url=${process.env.REACT_APP_API}`;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      if (document.hasFocus()) {
        console.log("still focus .....");
        // เปิดตัวช่วย download
        alert("ระบบจะทำการ download และติดตั้งเครื่องมือช่วยแสกน");

        const link = document.createElement("a");
        link.target = "_blank";
        link.download = "RcxScanSetup.exe";
        link.href = `${process.env.REACT_APP_API}download/RcxScanSetup.exe`;
        link.click();

        //setDlgState((pv) => ({ ...pv, show: true }));
      } else {
        setConfirm({
          show: true,
          title: (
            <div
              style={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div>กรุณารอระหว่าง Upload เอกสาร </div>
              <div style={{ color: "yellow" }}>
                กดปุ่มยืนยันเมื่อ Upload ไฟล์เสร็จแล้ว
              </div>
            </div>
          ),
          action: (e) => {
            if (e === true) {
              afterUploadFile();
            }
          },
        });
      }
      setLoadingScn(false);
    }, 3000);
  };

  //** Save Data */
  const saveData = async (evt) => {
    const dForm1 = new FormData(refForm1.current);
    const dForm2 = new FormData(refFrom2.current);
    const dForm3 = new FormData(refForm3.current);
    const fData1 = Object.fromEntries(dForm1);
    const fData2 = Object.fromEntries(dForm2);
    const fData3 = Object.fromEntries(dForm3);

    fData2.patients_idcard = fData2?.patients_idcard?.replace(/\D/g, "");

    let data = {
      StudyInfo: {
        ...dataX.studyInfo,
        ...fData1,
        ...fData2,
        ...fData3,
        pacs_study_id: selectedRow.pacs_study_id,
        physician_staff_id:
          dataX.studyInfo.physician_staffid == null
            ? -1
            : dataX.studyInfo.physician_staffid,
        radi_staff_id:
          dataX.studyInfo.radi_staffid == null
            ? -1
            : dataX.studyInfo.radi_staffid,
        custid: params.custid,
        custid_sender: params.custid_sender,
        price_list_id: params.price_list_id,
        is_old_study: showEditor.isOldStudy ? "y" : "n",
      },
      UserDetail: userDetail,
      ItemsInfo: [...priceData, ...priceDataRemove],
      ImportantEdit: importantEdit,
    };

    if (params.custid < 1) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกหน่วยงานตั้งเบิก",
          type: "error",
        }),
      );
      return;
    }
    if (params.custid_sender < 1) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกหน่วยงานผู้ส่งตรวจ",
          type: "error",
        }),
      );
      return;
    }

    if (data.StudyInfo?.patients_idcard == null) {
      dispatch(
        setReminder({
          show: true,
          message: "เลขที่บัตรประชาชน",
          type: "error",
        }),
      );
      return;
    }

    if (data.StudyInfo?.patients_idcard?.length < 13) {
      dispatch(
        setReminder({
          show: true,
          message: "เลขที่บัตรประชาชน",
          type: "error",
        }),
      );
      return;
    }

    if (params.price_list_id < 1) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกตารางราคา",
          type: "error",
        }),
      );
      return;
    }

    if (priceData.length < 1) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกรายการตรวจ",
          type: "error",
        }),
      );
      return;
    }

    if (dataX.studyInfo.radi_staffid < 1) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกรังสีแพทย์ก่อนครับ",
          type: "error",
        }),
      );
      return;
    }

    if (
      importantEdit.disableResultExpected == false &&
      dataX.studyInfo.diag_finish !== "y" &&
      new Date(dataX?.studyInfo?.result_expected) < new Date()
    ) {
      dispatch(
        setReminder({
          show: true,
          message: "เวลานัดรับผลไม่ถูกต้อง",
          type: "error",
        }),
      );
      return;
    }

    //** ข้อมูลเพื่อแจ้งไปที่ระบบ Local Pacs */
    let info = {
      userId: userDetail.userid,
      srcStaff: userDetail.staffid,
      targetStaff: 0,
      destStaff: dataX.studyInfo.radi_staffid,
      reqCommand: "31207",
      srcSessionType: 3,
      targetSessionType: 1,
      destSessionType: 2,
      PatientName: dataX.studyInfo?.patients_name,
      studyId: selectedRow.pacs_study_id,
    };

    let ret = await StudyService.SaveEditorInfo({
      ...data,
      ticketInfo: ws?.sendJsonMessage ? null : info,
    });
    if (ret != null) {
      // InformPacs(info);
      dispatch(
        setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" }),
      );
      setShowEditor({ show: false });
      setUpdateFlag(true);
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "พบปัญหาในการบันทึก กรุณาแจ้ง Admin",
        }),
      );
    }
  };

  //** แจ้ง PACS */
  const InformPacs = (info) => {
    if (ws?.sendJsonMessage) {
      ws?.sendJsonMessage(info);
    }
  };

  const readIdCard = () => {
    if (readyState !== 1) {
      AlertError("ไม่พบเครื่องอ่านบัตร", dispatch);
      return;
    }
    setSubLoading(true);
    sendMessage("RequestID");
  };

  const genDummyIdCard = () => {
    if (!dataX?.studyInfo?.custid_sender) {
      AlertError("กรุณาเลือกหน่วยงานส่งตรวจก่อน", dispatch);
      return;
    }
    if (!dataX?.studyInfo?.patientid) {
      AlertError("กรุณาระบุ HN", dispatch);
      return;
    }

    let brchDumm = "000000" + dataX.studyInfo?.custid_sender;
    brchDumm =
      "0000000000000" +
      brchDumm.substring(brchDumm.length - 6) +
      (dataX.studyInfo?.patientid ?? "").replace(/\D+/, "");

    brchDumm = FormatThaiCard3(brchDumm.substring(brchDumm.length - 13));
    setDataX((p) => {
      p.studyInfo.patients_idcard = brchDumm;
      return { ...p };
    });
  };

  //** ค้นหมอส่ง */
  const searchPhysician = () => {
    setSearhStateA({
      ...searchStateA,
      show: true,
      sql: {
        fields: [
          "a.staffid itemId",
          "concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
        ],
        tableName:
          " ba_staff a " +
          "inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n' " +
          "inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria:
          "b.flag_physician='y' and a.del_flag='n' and brchid=" +
          userDetail.brchid,
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 1000,
      },
      action: (data) => {
        dataX.studyInfo.physician_staffid = data.itemId;
        dataX.studyInfo.physician_staff_name = data.itemName;
        setSearhStateA({ show: false });
      },
    });
  };
  //** ค้นรังสีแพทย์ */
  const searchRadi = () => {
    if (
      dataX?.studyInfo?.diag_preliminay === "y" ||
      dataX?.studyInfo?.diag_official === "y"
    ) {
      dispatch(
        setReminder({
          show: true,
          message: "เคสนี้มีการออกผล Finalize แล้ว ไม่สามารถเปลี่ยนได้",
          type: "error",
        }),
      );
      return;
    }

    if (
      dataX?.studyInfo?.rad_accepted === "y" ||
      dataX?.studyInfo?.diag_draft === "y"
    ) {
      // xxx
      setConfirm({
        show: true,
        title: (
          <div
            style={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div>รังสีแพทย์ได้เริ่มอ่านผลไปแล้ว </div>
            <div>กรุณาทำการสื่อสารกับรังสีแพทย์ก่อน ...</div>
            <div style={{ color: "yellow" }}>
              ยืนยันว่าต้องการเปลี่ยนรังสีแพทย์
            </div>
          </div>
        ),
        action: (e) => {
          if (e === true) {
            searchRadiComfirmed();
          }
        },
      });
      return;
    } else {
      searchRadiComfirmed();
    }
  };

  const searchRadiComfirmed = () => {
    setSearhStateA({
      show: true,
      headerText: "รังสีแพทย์",
      sql: {
        fields: [
          "a.staffid itemId",
          "concat(p.shortname,a.firstname,space(3),a.lastname) itemName ",
        ],
        tableName:
          " ba_staff a " +
          "inner join ba_staff_type b on a.stafftypeid = b.stafftypeid and b.del_flag='n' and flag_radi_dummy='" +
          `${showEditor?.isOldStudy === true ? "y" : "n"}` +
          "' " +
          " inner join sy_prefix p on a.prefixid = p.prefixid and p.del_flag ='n' ",
        defaultCriteria: "b.flag_radi='y' and a.del_flag='n' ",
        criteriaFields: ["a.firstname", "a.lastname"],
        criteriaText: "",
        orderBy: ["a.firstname"],
        maxRows: 1000,
      },
      setDefaultValue: (data) => {
        dataX.studyInfo.radi_staffid = data.itemId;
        dataX.studyInfo.radi_staff_name = data.itemName;
      },
      action: (data) => {
        // event return from "Search"
        dataX.studyInfo.radi_staffid = data.itemId;
        dataX.studyInfo.radi_staff_name = data.itemName;
        setSearhStateA({ show: false });
      },
    });
  };
  //** ค้นโรงพยาบาล */
  const searchCust = ([targetId, targetName]) => {
    setSearhStateA({
      show: true,
      sql: {
        fields: ["custid itemId", "cust_short itemName"],
        tableName: " brch_customer ",
        defaultCriteria: " del_flag ='n' and brchid=" + userDetail.brchid,
        criteriaFields: ["cust_short"],
        criteriaText: "",
        orderBy: ["cust_short"],
        maxRows: 1000,
      },
      headerText: "โรงพยาบาล",
      action: (data) => {
        dataX.studyInfo[targetId] = data.itemId;
        dataX.studyInfo[targetName] = data.itemName;
        setParams((pv) => {
          pv[targetId] = data.itemId;
          return { ...pv };
        });
        setSearhStateA({ show: false });
      },
    });
  };

  //** ค้น Pricelist */
  const searchPriceList = () => {
    setSearchB({
      size: "lg",
      show: true,
      fieldId: "price_list_id",
      fieldName: "descript",
      sql: {
        fields: [
          "a.price_list_id",
          "a.docu_no",
          "a.descript",
          "cu.cust_short",
          "begin_date",
          "end_date",
        ],
        tableName:
          " brch_price_list a " +
          " inner join brch_customer cu on a.custid = cu.custid and cu.del_flag='n' ",
        defaultCriteria:
          " a.del_flag ='n' and a.brchid=" +
          userDetail.brchid +
          " and date_format(begin_date,'%y%m%d') <= date_format(current_date(),'%y%m%d') " +
          " and date_format(end_date,'%y%m%d') >= date_format(current_date(),'%y%m%d') ",
        criteriaFields: ["a.docu_no", "cu.cust_short"],
        criteriaText: "",
        orderBy: ["a.docu_no"],
        maxRows: 1000,
      },
      action: (data) => {
        // รับคืนข้อมูล
        dataX.studyInfo.price_list_id = data.price_list_id;
        dataX.studyInfo.descript = data.descript;
        setParams((pv) => {
          pv.price_list_id = data.price_list_id;
          return { ...pv };
        });
        setSearchB((pv) => {
          pv.show = false;
          return { ...pv };
        });
      },
      columns: [
        {
          dataField: "docu_no",
          text: "เลขเอกสาร",
          sort: true,
          headerStyle: GetHeaderStyle("120px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "descript",
          text: "รายการ",
          sort: true,
          headerStyle: GetHeaderStyle("auto"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
        },
        {
          dataField: "begin_date",
          text: "เริ่มต้น",
          sort: true,
          headerStyle: GetHeaderStyle("100px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
          formatter: (cell, row) => {
            return FormatThaiDate(cell);
          },
        },
        {
          dataField: "end_date",
          text: "สิ้นสุด",
          sort: true,
          headerStyle: GetHeaderStyle("100px"),
          style: { border: "none", color: "var(--table-text-color)" },
          filter: textFilter({ placeholder: "..." }),
          formatter: (cell, row) => {
            return FormatThaiDate(cell);
          },
        },
      ],
    });
  };

  //** สิทธิรักษา */
  const patrightAction = (e) => {
    setParams((pv) => {
      pv.brchpatrightid = e.target.value;
      return { ...pv };
    });
  };

  //** สร้างฟิลด์ข้อมูล */

  const setFieldGroups = () => {
    refForm1.current?.reset();
    setFieldGroup1([
      {
        label: "ชื่อผู้ป่วย(Th)",
        oName: "patients_name",
        require: true,
        type: "text",
        defaultValue: dataX?.studyInfo?.patients_name ?? "",
        onChange: (e) =>
          setDataX((pv) => {
            pv.studyInfo.patients_name = e.target.value;
            return { ...pv };
          }),
      },
      {
        label: "ชื่อผู้ป่วย(En)",
        oName: "patients_name_eng",
        require: true,
        type: "text",
        defaultValue: dataX?.studyInfo?.patients_name_eng ?? "",
        onChange: (e) =>
          setDataX((pv) => {
            pv.studyInfo.patients_name_eng = e.target.value;
            return { ...pv };
          }),
      },
      { label: "อายุ", oName: "patients_age", require: true, type: "text" },
      {
        label: "HN",
        oName: "patientid",
        require: true,
        type: "text",
        onChange: (e) => {
          setDataX((p) => {
            p.studyInfo.patientid = e.target.value;
            return { ...p };
          });
        },
      },
      {
        label: "เพศ",
        oName: "patients_sex",
        require: true,
        type: "select",
        rows: [
          { id: "M", name: "ชาย" },
          { id: "F", name: "หญิง" },
        ],
      },
      {
        label: "Accession No.",
        oName: "accession_number",
        type: "text",
        onChange: (e) => {
          setDataX((p) => {
            p.studyInfo.accession_number = e.target.value;
            return { ...p };
          });
        },
      },
      {
        label: "Std. Description",
        oName: "study_description",
        type: "text",
        onChange: (e) => {
          setDataX((p) => {
            p.studyInfo.study_description = e.target.value;
            return { ...p };
          });
        },
      },
      {
        label: "Std. Instance UID",
        oName: "study_instance_uid",
        disabled: true,
        type: "text",
      },
      { label: "Series/Images", oName: "series_images_cnt", type: "label" },
    ]);

    setFieldGroup2([
      {
        label: "หน่วยงานส่งตรวจ",
        oName: "sender_name",
        type: "find",
        click: () => {
          searchCust(["custid_sender", "sender_name"]);
        },
        refKey: null,
        refValue: null,
      },

      {
        label: "หน่วยงานเรียกเก็บ",
        oName: "cust_short",
        type: "find",
        click: () => {
          searchCust(["custid", "cust_short"]);
        },
        refKey: null,
        refValue: null,
      },

      {
        label: "แผนก",
        oName: "brchwardid",
        type: "select",
        rows: props?.refData?.Wards,
      },
      {
        label: "สิทธิรักษา",
        oName: "brchpatrightid",
        require: true,
        type: "select",
        rows: props?.refData?.PatientRight,
        onChange: patrightAction,
        onClick: patrightAction,
      },

      {
        label: "เลขที่บัตรประชาชน",
        oName: "patients_idcard",
        defaultValue: dataX?.studyInfo?.patients_idcard ?? "",
        require: true,
        type: "find-text",
        tooltip: "ไม่ทราบเลขที่บัตร",
        buttonCaption: <FaExclamation size={10} />,
        onChange: handlelIdCardChange,
        click: (e) => genDummyIdCard(),
        button2Click: (e) => readIdCard(),
        button2Caption: subLoading ? (
          <Oval height={20} />
        ) : (
          <FaRegIdCard size={20} />
        ),
        button2Tooltip: "อ่านจากเครื่องอ่านบัตร",
        showButton2: true,
      },

      {
        label: "แพทย์เจ้าของไข้",
        oName: "physician_staff_name",
        type: "find",
        click: searchPhysician,
      },

      {
        label: "รังสีแพทย์",
        oName: "radi_staff_name",
        type: "find",
        // disabled:
        //   dataX?.studyInfo?.rad_accepted === "y" ||
        //   dataX?.studyInfo?.diag_finish === "y"
        //     ? true
        //     : false,
        click: searchRadi,
        refKey: null,
        refValue: null,
      },

      {
        label: "ความเร่งด่วน",
        oName: "urgenttypeid",
        type: "select",
        onChange: (e) => {
          setImportantEdit((pv) => {
            pv.changedUrgency = true;
            pv.disableResultExpected = e.target.value == 1 ? false : true;
            return { ...pv };
          });
        },
        rows: props?.refData?.UrgentType,
      },
      {
        label: "เวลารับผล",
        oName: "result_expected",
        type: "datetime",
        disabled: importantEdit.disableResultExpected,
        oState: [resultExpected, setResultExpected],
        onClick: (e) => {
          if (importantEdit.disableResultExpected) {
            dispatch(
              setReminder({
                show: true,
                message:
                  "ในกรณีไม่ใช่เคส Normal ระบบจะทำการคำนวณเวลาให้อีกครั้ง",
                type: "error",
              }),
            );
          }
        },
        onChange: (e) => {
          setResultExpected(e);
          setDataX((p) => {
            p.studyInfo.result_expected = e;
            return { ...p };
          });
        },
      },

      {
        label: "ตารางราคา",
        oName: "descript",
        type: "find",
        click: searchPriceList,
      },
    ]);

    setFieldGroup3([
      {
        label: "หมายเหตุ",
        oName: "study_remark",
        require: true,
        type: "text_area",
        textRows: 5,
        onChange: (e) => {
          setImportantEdit((pv) => {
            pv.changedRemark = true;
            return { ...pv };
          });
        },
      },
    ]);
  };

  //** Show Image */
  const imageButtonClick = (item) => {
    setShowImage({
      show: true,
      imagePath: process.env.REACT_APP_API + "/" + item.image_path,
      imageName: item.image_name,
    });
  };

  //** Open link */
  const openLink = (item) => {
    // window.location.href = process.env.REACT_APP_API + "/" + item.image_path;
    let url = process.env.REACT_APP_API + "/" + item.image_path;
    window.open(url, "_blank", "noreferrer");
  };

  /*** -------------------------------------------------- */
  const SearchBrchGood = () => {
    if (dataX && dataX.studyInfo.price_list_id === null) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกตารางราคา",
          type: "error",
        }),
      );
      return;
    }

    setSearchGood({
      show: true,
      action: (data, [setState]) => {
        // Adding Item into good and service tmporary table
        for (let i = 0; i < priceData.length; i++) {
          if (priceData[i].price_list_det_id === data.price_list_det_id) {
            dispatch(
              setReminder({ show: true, message: "รายการซ้ำ", type: "error" }),
            );
            return;
          }
        }
        setPriceData((pv) => [
          ...pv,
          { ...data, item_id: -1, qty: 1, total: data.price, del_flag: "n" },
        ]);
        setState({ show: false });
        setImportantEdit((pv) => {
          pv.changedItem = true;
          return { ...pv };
        });
      },
    });
  };

  //** Action หลังจากทำการ upload ไฟล์แล้ว */

  const afterUploadFile = () => {
    updateAttachedFile(() => {
      setShowUpload({ show: false });
    });
  };

  //**Handle drop request */
  const handleDrop = (evt) => {
    evt.preventDefault();
    if (
      dataX.studyInfo.rad_resulted === "y" ||
      dataX.studyInfo.diag_finish === "y"
    ) {
      dispatch(
        setReminder({
          show: true,
          message: (
            <>
              <div>รังสีแพทย์บันทึกผลแล้ว</div> <div>ไม่สามารถเพิ่มไฟล์ได้</div>
            </>
          ),
          type: "error",
        }),
      );
      return;
    }

    if (evt.dataTransfer.files[0].size > 2000000) {
      dispatch(
        setReminder({
          show: true,
          message: "ขนาดไฟล์ได้ไม่เกิน 2 Mbyte",
          type: "error",
        }),
      );
      return;
    }

    setFileDrop(evt.dataTransfer.files);

    setAutoUpload({
      show: true,
      action: () => {
        setFileDrop(null);
        updateAttachedFile(() => {
          setAutoUpload({ show: false });
        });
      },
    });
  };

  //**Handle dragover */
  const handleDragOver = async (evt) => {
    evt.preventDefault();
  };

  let allowSave = true; // dataX.studyInfo?.diag_finish === "n";

  // dataX.studyInfo?.rad_resulted === "n"

  const openViewer = () => {
    // let test =
    //   "microdicom://param=fd&value=D:\\Test\\LocalDicom\\1.2.840.113845.11.1000000002170592405.20231230161212.1633479";
    let urlProtocol = "";

    switch (dataX?.studyInfo?.viewer_name) {
      case "microdicom":
        urlProtocol =
          "microdicom://param=fd&value=" +
          dataX?.studyInfo?.dcm_folder +
          "\\" +
          dataX?.studyInfo?.study_instance_uid;
        break;
      case "radiant":
        urlProtocol =
          "radiant://n=d&v=" +
          dataX?.studyInfo?.dcm_folder +
          "\\" +
          dataX?.studyInfo?.study_instance_uid;
        break;

      default:
        urlProtocol = "";
        break;
    }

    if (urlProtocol != "") {
      var a = document.createElement("a");
      //  a.title = "";
      a.href = urlProtocol;
      document.body.appendChild(a);
      a.click();
    }
  };

  const requestReUpload = async () => {
    let ret = await StudyService.RequestOldStudyFile({
      StudyInfo: {
        pacs_study_id: dataX?.studyInfo?.pacs_study_id,
        study_instance_uid: dataX?.studyInfo?.study_instance_uid,
      },
      UserInfo: { userid: userDetail.userid },
    });

    if (ret != null) {
      dispatch(
        setReminder({
          show: true,
          message: "แจ้งการขอ upload ไฟล์ไปที่ Server เรียบร้อยแล้ว",
          type: "success",
        }),
      );
    }
  };

  /**  Show Invoice */
  const showInvoiceEditor = () => {
    setInvoiceFrm({
      show: true,
      study: dataX.studyInfo,
      items: [priceData, setPriceData],
      action: () => {},
    });
  };
  const theme = useSelector((s) => s.theme.theme);

  /*** -------------------------------------------------- */
  return (
    <MyModal
      data-theme={theme.themeName}
      show={showEditor.show}
      size="xl"
      onHide={handleClose}
      backdrop={true}
      centered
      style={{ padding: "10px" }}
    >
      <ModalHeaderBlack closeButton>
        <FcReadingEbook
          style={{ color: "yellow", fontSize: "30px", margin: "0 5px 0 5px" }}
        />
        ส่งอ่าน {props.formName}
        {dataX && dataX.studyInfo.action_event ? (
          <div
            style={{ color: "yellow", marginInline: "10px", fontSize: "14px" }}
          >
            [ {dataX && dataX.studyInfo.action_event} ]
          </div>
        ) : (
          <></>
        )}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        <div style={modalBlackStyle1}>
          <HBox style={{ flex: "1", display: "flex" }}>
            <div style={{ flex: "1", display: "flex" }}>
              <BoxLeft>
                <BoxHeader>
                  <Button>
                    <AiOutlineSearch /> ข้อมูลคนไข้จากเครื่องตรวจ{" "}
                  </Button>{" "}
                </BoxHeader>
                {fieldGroup1 ? (
                  <FormAutoB
                    {...{
                      formId: "form1",
                      items: fieldGroup1,
                      data: dataX ? dataX.studyInfo : null,
                      refTo: refForm1,
                      submit: null,
                    }}
                  />
                ) : null}
              </BoxLeft>
              <BoxRight style={{ maxWidth: "50%" }}>
                <BoxHeader>
                  <Button>
                    <AiOutlineInfo style={{ backgroundColor: "black" }} />
                    ข้อมูลทะเบียนคนไข้ส่วนกลาง
                  </Button>
                </BoxHeader>
                {fieldGroup2 ? (
                  <FormAutoB
                    {...{
                      formId: "form2",
                      items: fieldGroup2,
                      data: dataX ? dataX.studyInfo : null,
                      refTo: refFrom2,
                      submit: null,
                    }}
                  />
                ) : null}
              </BoxRight>
            </div>
          </HBox>

          <HBox
            style={{
              margin: "0 0 0 5px",
              padding: "0 0 0 0px",
            }}
          >
            <Button
              style={{ margin: "1px 0 0 5px" }}
              onClick={() => SearchBrchGood()}
            >
              <AiOutlinePlus style={{ color: "var(--icon-fore)" }} />
              เพิ่มรายการค่าบริการ
            </Button>
            <span
              style={{
                paddingTop: "10px",
                color: "#a7a3a3",
                marginLeft: "10px",
              }}
            >
              รายการตัวเลือกจะขึ้นสิทธิรักษา + ตารางราคา
            </span>
          </HBox>

          <VBox style={vboxStyle1}>
            <StudyParts
              {...{
                priceData: [priceData, setPriceData],
                priceDataRemove: [priceDataRemove, setPriceDataRemove],
                updateImportant: [importantEdit, setImportantEdit],
              }}
            />
          </VBox>

          <HBox style={{ marginTop: "5px" }}></HBox>

          <div style={divAttachStyle1}>
            <div>
              <BiLayer
                size={30}
                color="var(--icon-fore)"
                style={{ marginInlineEnd: "5px" }}
              />
              รายการไฟล์แนบ
              <span style={{ marginInline: "10px" }}>(ลากและวางไฟล์)</span>
            </div>
            <span>
              <Button
                style={{ marginLeft: "5px" }}
                onClick={(e) => {
                  // setShowUpload({ show: true, action: afterUploadFile });
                  openRcxScanUrl(e);
                }}
              >
                <MdScanner style={{ color: "yellow", marginRight: "2px" }} />
                แสกน + Upload
              </Button>
              <Button
                style={{ marginLeft: "5px" }}
                onClick={() => {
                  setShowUpload({ show: true, action: afterUploadFile });
                }}
              >
                <AiOutlinePaperClip
                  style={{ color: "yellow", marginRight: "2px" }}
                />
                Upload ไฟล์
              </Button>
              <Button
                style={{ marginLeft: "5px" }}
                onClick={() => handleClibboard()}
              >
                <BiClipboard style={{ color: "yellow", marginRight: "3px" }} />
                รับภาพจาก Clipboard{" "}
                <span style={{ color: "#121412" }}> (Ctrl+V)</span>
              </Button>
            </span>
          </div>
          <HBox
            style={hBoxUploadStyle}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <FileListBox>
              <div style={fileListBoxStyle}>
                <div style={{ color: "var(--fore-secondary)" }}>
                  ++ ลากไฟล์วางที่นี่ ++
                </div>
              </div>
              {dataX &&
                dataX.attachedFile &&
                dataX.attachedFile.map((item, i) => {
                  switch (item.upload_type) {
                    case uploadType.FILE: //1
                      return (
                        //*** ไฟล์ Upload */
                        <SpanText>
                          <span
                            style={{ marginTop: "3px" }}
                            onClick={() => openLink(item)}
                          >
                            <RiAttachmentLine style={styles.fileIcon} />
                            {`${item.image_name}`}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={(props) => (
                              <Tooltip {...props}>ลบ</Tooltip>
                            )}
                          >
                            <SpanBadge
                              onClick={() => {
                                deleteImage(item);
                              }}
                            >
                              x
                            </SpanBadge>
                          </OverlayTrigger>
                        </SpanText>
                      );
                    case uploadType.CAPTURED: //2
                      return (
                        <SpanText>
                          <span
                            style={{ marginTop: "3px" }}
                            onClick={() => openLink(item)}
                          >
                            <FcPicture style={styles.fileIcon} />
                            {`${item.image_name}`}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={(props) => (
                              <Tooltip {...props}>ลบ</Tooltip>
                            )}
                          >
                            <SpanBadge
                              onClick={() => {
                                deleteImage(item);
                              }}
                            >
                              x
                            </SpanBadge>
                          </OverlayTrigger>
                        </SpanText>
                      );
                    default:
                      return (
                        <ImageLinkButton
                          onClick={() => imageButtonClick(item)}
                        />
                      );
                  }
                })}
            </FileListBox>
          </HBox>

          <HBox>
            <BoxRight>
              {fieldGroup3 ? (
                <FormAutoB
                  {...{
                    formId: "form3",
                    items: fieldGroup3,
                    data: dataX ? dataX.studyInfo : null,
                    submit: null,
                    refTo: refForm3,
                  }}
                />
              ) : null}
            </BoxRight>
          </HBox>
        </div>
      </ModalBodyBlack>

      <ModalFooterBlack>
        <div
          style={{
            display: "flex",
            flex: "1",
            justifyContent: "space-between",
            marginInline: "0px",
          }}
        >
          <div>
            <Button onClick={(e) => openViewer()}>
              <img
                src={XrayImage}
                alt=""
                style={{
                  width: "30px",
                  marginInline: "0px",
                }}
              />{" "}
              {/* เปิดภาพด้วย {dataX?.studyInfo?.viewer_display_name} */}
              Viewer
            </Button>
            <Button
              style={{ marginInline: "10px" }}
              onClick={() => {
                const url =
                  process.env.REACT_APP_API +
                  "api/studyinfo/getstudy?suid=" +
                  dataX?.studyInfo?.study_instance_uid;

                const link = document.createElement("a");
                link.target = "_self";
                link.download = link.href = url;
                link.click();
              }}
            >
              <AiOutlineDownload size={30} />
              Download
            </Button>

            <Button
              style={{ marginInline: "10px" }}
              onClick={() => {
                requestReUpload();
              }}
            >
              <AiOutlineUpload color="yellow" size={30} />
              Re-Upload
            </Button>

            <Button
              style={{ marginInline: "10px" }}
              onClick={() => {
                showInvoiceEditor();
              }}
            >
              <FaRegFileAlt color="yellow" size={30} />
              ออกใบแจ้งหนี้
            </Button>
          </div>
          <div></div>
          <div>
            {allowSave && !showEditor.isOldStudy ? (
              <Button
                variant="primary"
                style={{ marginInline: "10px" }}
                onClick={() => {
                  saveData();
                }}
              >
                <FcReadingEbook
                  size={30}
                  style={{ color: "yellow", marginInline: "5px" }}
                />
                บันทึก/ส่งอ่าน
              </Button>
            ) : (
              <></>
            )}

            {showEditor.isOldStudy ? (
              <Button
                variant="success"
                style={{ marginInline: "10px" }}
                onClick={() => {
                  saveData();
                }}
              >
                <AiOutlineHistory
                  size={30}
                  style={{ color: "yellow", marginInline: "5px" }}
                />
                ส่ง Study เก่า
              </Button>
            ) : (
              <></>
            )}

            {/* <Button variant="info"  disabled = {true}><FaHandsHelping style={{color:'yellow'}}/>  ส่งปรึกษา</Button> */}
            <Button variant="danger" onClick={handleClose}>
              <AiOutlineClose size={30} />
              ปิด
            </Button>
          </div>
        </div>
      </ModalFooterBlack>

      <FileUploader
        {...{ showUpload, setShowUpload, selectedRow, userDetail }}
      />
      <ClipboardPaster
        {...{ showClipboard, setClipboard, selectedRow, userDetail }}
      />
      <FileUploadAutoPreview
        {...{ autoUpload, setAutoUpload, fileDrop, selectedRow, userDetail }}
      />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />

      <FormInvoice {...{ editor: [invoiceFrm, setInvoiceFrm] }} />
    </MyModal>
  );
}

const HBox = styled.div`
  /* padding: 3px; */
  display: flex;
  /* align-items: center; */
`;

const VBox = styled.div``;

const BoxLeft = styled.div`
  flex: 1;
  display: flex;
  padding: 5px;
  flex-direction: column;
`;

const BoxRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 5px;
`;

const BoxHeader = styled.div`
  color: var(--caption-fore-color);
  padding: 5px 0 5px 0;
`;

const FileListBox = styled.p`
  padding: 2px 1px 10px 5px;
  color: var(--caption-fore-color);
  flex: 1;
  opacity: 0.8;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: fit-content(0%);

  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap; */
`;

const ImageLinkButton = styled.div`
  text-decoration: none;
  color: var(--icon-fore);
  cursor: pointer;
  padding: 5px;
  margin: 1px 5px 10px 5px;
  border: 1px solid var(--date-border);
  transition: 100ms;
  font-size: 13px;
  border-radius: 5px;
  word-break: break-word; // break-all;
  :hover {
    transition: 700ms;
    text-decoration: none;
    border: 1px solid #b9ecd7;
    border-radius: 5px;
    padding: 5px;
    color: #d5daff;
  }
`;

export default StudyEditor;

const styles = {
  fileIcon: {
    marginInline: "5px",
    width: "15px",
    height: "15px",
    color: "#96e307",
  },
};

const SpanText = styled.div`
  /* font-size: 12px; */
  /* color: var(--icon-fore); */
  margin: 0px 5px 2px 5px;
  // padding: 0 5px 5px 5px;
  padding: 2px 0.65em;
  border-radius: 5px;
  line-height: 25px;
  cursor: pointer;
  transition: 1.5s;

  flex: 1;
  &:hover {
    color: var(--select-item-color);
    transition: 1.5s;
  }
`;

const SpanBadge = styled.span`
  background-color: red;
  padding: 0.35em 0.65em;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  /* white-space: nowrap; */
  vertical-align: baseline;
  border-radius: 0.25rem;
  margin-left: 5px;
  /* margin-top: 2px; */
  display: none;

  //** animation */
  transition: 1.5s;

  ${SpanText}:hover & {
    transition: 1.5s;
    display: inline-block;
  }
  &:hover {
    cursor: pointer;
  }
`;

const fileListBoxStyle = {
  position: "absolute",
  left: "0px",
  right: "0px",
  display: "flex",
  flex: "1",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100px",
  opacity: "0.7",
  zIndex: "-1",
  fontSize: "30px",
};

const hBoxUploadStyle = {
  marginTop: "5px",
  maxHeight: "100px",
  overflowY: "scroll",
  border: "1px solid var(--date-border)",
  background: "var(--bg-primary)",
  margin: "1px 5px 1px 5px",
  minHeight: "100px",
};

const modalBlackStyle1 = {
  width: "99%",
  display: "flex",
  flex: "1",
  flexDirection: "column",
  overflowX: "scroll",
};

const vboxStyle1 = {
  width: "100%",
  height: "150px",
  overflowY: "scroll",
  border: "0px solid var(--date-border)",
  // margin: "5px 5px 0px 5px",
  paddingRight: "5px",
  background: "var(--bg-primary)",
};

const divAttachStyle1 = {
  color: "var(--caption-fore-color)",
  textAlign: "center",
  margin: "10px 5px 5px 5px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
